import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// Decorat
import { withWindow } from '../../decorators/window';
import cx from 'classnames';

import HeaderMain from './header-main';
import HeaderMenuHamburger from './header-menu-hamburger';
import AmaiaChat from './amaia/AmaiaChat';
import {
  getCookie,
  deleteCookie,
  getTabIndex,
  isJsonObject,
  removeTabIndex,
  retriveActualHostUrl,
  updateSFLangFromURL,
} from '../../utilities/helpers';

import {
  activatePersistentLoginPopup,
  checkSessionAction,
  disablePersistentLoginPopup,
  logoutSessionAction,
  retrieveCorporateProfileUserAction,
  retrieveProfileUserAction,
  updateShoppingCart,
} from '../../../redux/actions/index';

import { ACTION_LOGIN, LOGIN_ACTION } from '../../../redux/actions/Interaction-studio-action-creators';
import * as actions from '../../../redux/actions/index';
import ErrorBar from '../errors/error-bar';
import ErrorBarIcon from '../errors/error-bar-icon';
import {
  metricaUserLoginCpAcount,
  metricaUserLoginStep,
  metricaUserLoginCobranded,
  metricaUserLoginCobrandedCard,
  metricaUserLoginFail,
  metricaUserSignupFail,
  metricaLogin,
} from '../../../../src/scripts/utilities/metricas-login';
import moment from 'moment';
import SearchModal from './search-modal';
import { sendAnalytics } from '../../analytics/tracker';
import registerFailCPTracking from '../../analytics/creators/manage';
import { USER_PROFILE_LOGIN_FORM_ID } from '../../constants/form-ids';
import { setModalLoginMethod } from '../../../redux/actions/openModalLogin';

const USE_AMAIA_CHAT = true;

const mapStateToProps = state => ({
  actionLogin: state.InteractionStudio.actionLogin,
  activeBannerUpdateConsent: state.ActiveBannerUpdateConsent,
  // cartSessionState: state.SessionValidation,
  codeInicativeAccount: state.UserProfileSession.codeInicativeAccount,
  contentForm: state.form[USER_PROFILE_LOGIN_FORM_ID],
  errorActionable: state.UserProfileSession.errorActionable,
  errorActionType: state.UserProfileSession.errorActionType,
  errorExtraInfo: state.UserProfileSession.errorExtraInfo,
  errorMsg: state.UserProfileSession.errorMsg,
  errorStatusCode: state.UserProfileSession.errorStatusCode,
  helperTraslatedCopy: state.LanguageBundle.helperTraslatedCopy,
  isActiveFlowCorporate: state.Corporate.isActiveFlowCorporate,
  isActivePersistentLoginPopup: state.UserProfileSession.isActivePersistentLoginPopup,
  isInvalidSession: state.UserProfileSession.isInvalidSession,
  isSignIn: state.UserProfileSession.isSignIn,
  isValidSession: state.UserProfileSession.isValidSession,
  loadingPorfileRequestStart: state.UserProfileSession.loadingPorfileRequestStart,
  menuPromotions: state.MenuPromotions.menuPromotions,
  metrixEmail: state.UserProfileSession.metrixEmail,
  sourceOpenModalLogin: state.openModalLogin.sourceOpenModalLogin,
  loginMethod: state.modalLoginMethod.loginMethod,
  signInFail: state.UserProfileSession.signInFail,
  storefront: state.Manage.storefront,
  touchPointType: state.TouchPointCpProperty.touchPointType,
  travelInformation: state.TravelInformation.travelInformation,
  userBalance: state.Manage.userBalance,
  userCorporate: state.Corporate.userCorporate,
  userFirstName: state.UserProfileSession.userFirstName,
  userInitials: state.UserProfileSession.userInitials,
  userProfile: state.UserProfileSession.userProfile,
  userProfLogout: state.UserProfileSession.userProfLogout,
  userToken: state.UserProfileSession.userToken,
  remainingAttemptsRetrieveProfile: state.UserProfileSession.remainingAttemptsRetrieveProfile,
});
class Header extends Component {
  constructor() {
    super();

    this.state = {
      inputValueSearchModal: false,
      modalSearch: false,
      modalSearchClose: false,
      showBanner: false,
      showHamburger: false,
      showSubmenu: false,
      isRetrieveCorporateSession: false,
      isRetrieveCorporateSuccess: false,
    };

    this.handleCloseHamburger = this.handleCloseHamburger.bind(this);
    this.handleCloseSearchModal = this.handleCloseSearchModal.bind(this);
    this.handleCloseSubmenu = this.handleCloseSubmenu.bind(this);
    this.handleOpenHamburger = this.handleOpenHamburger.bind(this);
    this.handleOpenSubmenu = this.handleOpenSubmenu.bind(this);
    this.handleOpenSearchModal = this.handleOpenSearchModal.bind(this);
    this.trackLoginUsername = this.trackLoginUsername.bind(this);
    this.retrieveCorporateProfileData = this.retrieveCorporateProfileData.bind(this);
    this.validatorCode = '';
    this.checkPoint1 = false;
    this.checkPoint2 = false;
  }

  componentWillMount() {
    const {
      pnrInfo,
    } = this.props;

    const userCorporateData = JSON.parse(getCookie('userSessionCorporate'));
    const userCorporateDataExist = Boolean(userCorporateData);
    const corporatePNR = Boolean(pnrInfo?.isCorporateFlow && pnrInfo?.corporateFlow);
    if (userCorporateDataExist || corporatePNR) {
      this.dispatchCookieUserCases('retrieve_corporate_profile');
    } else {
      this.dispatchCookieUserCases('retrieve_profile');
    }
  }

  componentDidMount() {
    const {
      dispatch,
      isSignIn,
      history,
    } = this.props;

    this.dispatchCookieUserCases('check_session');

    if (!isSignIn && localStorage.getItem('initials')) {
      dispatch(activatePersistentLoginPopup());
      /*
        Se limpia el tabIndex para que esto sea controlado
        solo por los actions del menu hamburger profile
      */
      removeTabIndex();
    }

    if (history) {
      updateSFLangFromURL(window.location.href);
      this.unlisten = history.listen((location) => {
        updateSFLangFromURL(location.pathname);

        const QSIApi = window.QSI && window.QSI.API;
        if (QSIApi) {
          QSIApi.unload();
          QSIApi.load();
          QSIApi.run();
        }
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      activeBannerUpdateConsent,
      breakpointNewDesign,
      //  cartSessionState,
      codeInicativeAccount,
      country,
      dispatch,
      isActivePersistentLoginPopup,
      isSignIn,
      language,
      pnrInfo,
      storefront,
      touchPointType,
      userToken,
    } = this.props;

    const {
      isRetrieveCorporateSession,
      isRetrieveCorporateSuccess,
    } = this.state;

    const newBreakpoint = nextProps.breakpointNewDesign;
    const { actionLogin: actionLoginNext, signInFail, isInvalidSession } = nextProps;
    const pathname = window.location.pathname;
    this.validatorCode = nextProps.codeInicativeAccount;
    // Invalid Session
    if (isInvalidSession && !this.props.isInvalidSession) {
      this.dispatchCookieUserCases('user_logout');
      const userCorporateData = JSON.parse(getCookie('userSessionCorporate'));
      const validUserCorporate = userCorporateData?.isUserCorporate;

      if (validUserCorporate) {
        deleteCookie('userSessionCorporate');
        const storefront = this.getStorefrontFromUrl();
        window.location.replace(`/${storefront}`);
      }
    }

    const userCorporateData = JSON.parse(getCookie('userSessionCorporate'));
    const isCorporateFlow = userCorporateData?.isUserCorporate;

    // Recuperacion de cuenta corporativa
    if (!isRetrieveCorporateSession && isCorporateFlow) {
      this.setState({ isRetrieveCorporateSession: true });
      dispatch(actions.setRetrieveCorporateData(true));
    }
    const userCorporateDataExist = Boolean(userCorporateData);
    // Recuperacion de cuenta corporativa en store corporativo
    if (isSignIn && !isInvalidSession && userCorporateDataExist && isRetrieveCorporateSession && !isRetrieveCorporateSuccess) {
      this.retrieveCorporateProfileData();
      this.setState({ isRetrieveCorporateSuccess: true });
    }

    if (activeBannerUpdateConsent !== nextProps.activeBannerUpdateConsent && nextProps.activeBannerUpdateConsent.activate) {
      this.setState({ showBanner: true });
    }
    // Close hamburger on breakpoint change
    if (newBreakpoint !== breakpointNewDesign && this.state.showHamburger) {
      const htmlTag = document.getElementsByTagName('html')[0];
      htmlTag.classList.remove('Modal-open--state');

      this.setState({
        showHamburger: false,
        showSubmenu: false,
      });
    }

    const grantAccess = isJsonObject(getCookie('manageApiError')) ? JSON.parse(getCookie('manageApiError')) : null;
    if ((grantAccess && grantAccess.code === '15111802') || (grantAccess && grantAccess.code === '15111801') || (grantAccess && grantAccess.code === '15111803')) {
      localStorage.removeItem('isLoginForm');
      this.signInFail = true;
      const errorType = '';
      const button = localStorage.getItem('loginButton');
      metricaUserLoginFail(dispatch, pathname, errorType, button);
      this.validatorCode = '';
      this.checkPoint1 = false;
      this.checkPoint2 = true;
    }
    // Metricas login
    if (!isSignIn && nextProps.isSignIn) {
      const { contentForm } = this.props;
      // Metrica login cp account
      const button = localStorage.getItem('loginButton');
      const cobrandCards = (nextProps.userProfile.account.cobrandCardCollection && nextProps.userProfile.account.cobrandCardCollection != undefined) ? nextProps.userProfile.account.cobrandCardCollection._collection.length : 0;
      const coBrandedCard = cobrandCards ? nextProps.userProfile.account.cobrandCardCollection._collection : null;
      const ffNumber = nextProps.userProfile.ffNumber || 'NA';

      metricaUserLoginCpAcount(dispatch, pathname, button, contentForm, coBrandedCard, ffNumber, touchPointType);

      if (nextProps.userProfile) {
        const userProfileCart = {
          _meta: {
            class: nextProps.userProfile.account._meta.class,
          },
          account: {
            balance: nextProps.userBalance?.pointsBalance || nextProps.userProfile.account?.balance,
            tier: nextProps.userProfile.account.tier,
            tierExpirationDate: nextProps.userProfile.account.tierExpirationDate,
            frequentFlyerNumber: nextProps.userProfile.ffNumber,
            frequentFlyerProgram: 'AM',
            login: true,
          },
        };
        if (pnrInfo) {
          pnrInfo.cart.setManageUserProfileAccount(userProfileCart);
          dispatch(updateShoppingCart(country, pnrInfo.cart.cartId, language, pnrInfo, false, 1, userToken));
        }
        const userType = 'Profile';
        const clubPremierID = nextProps.userProfile.ffNumber;
        // const salesForceId = 'null'; dato a definir
        const tierLvl = nextProps.userProfile.account.tier;
        const yearProfile = nextProps.userProfile.passengerData.dateOfBirth;
        const anio = yearProfile.substr(0, 4);
        const anioNacimiento = parseInt(anio, 10);
        const fecha = new Date();
        const anioActual = fecha.getFullYear();
        const grupo = anioActual - anioNacimiento;
        const balance = nextProps.userBalance?.pointsBalance || nextProps?.userProfile?.account?.balance;
        const genero = nextProps.userProfile.passengerData.gender;
        let travelers = 0;
        let creditCards = 0;

        if (nextProps.userProfile.travelers && nextProps.userProfile.travelers._collection) {
          travelers = nextProps.userProfile.travelers._collection.length;
        }

        if (nextProps.userProfile.personalCreditCards && nextProps.userProfile.personalCreditCards._collection) {
          creditCards = nextProps.userProfile.personalCreditCards._collection.length;
        }

        const cobrandCards = (nextProps.userProfile.account.cobrandCardCollection && nextProps.userProfile.account.cobrandCardCollection != undefined) ? nextProps.userProfile.account.cobrandCardCollection._collection.length : 0;
        const cardType = creditCards > 0 ? nextProps.userProfile.personalCreditCards._collection.map(card => `${card.cardType}`).join(':') : '';
        const isCobrand = creditCards > 0 ? nextProps.userProfile.personalCreditCards._collection.map(card => `${card.isCobranCard ? 1 : 0}`).join(':') : '';
        const paymentMethods = `${cardType}/${isCobrand}`;
        const tierExpirationDate = (nextProps.userProfile.account && nextProps.userProfile.account.tierExpirationDate) ? moment(nextProps.userProfile.account.tierExpirationDate, 'DD-MM-YYYY').format('YYYYMMDD') : '';
        const pointsToNextTier = nextProps.userProfile.account.pointsToNextTier || '';
        const qualificablePoints = nextProps.userProfile.account.qualificablePoints || 0;
        const extraBaggagesNumber = nextProps.userProfile.account.benefits._collection[0].extraBagagesNumber || 'NA';
        const freeAMPlusSeat = (nextProps.userProfile.account.benefits && nextProps.userProfile.account.benefits._collection[0].freeAMPlusSeat) ? 1 : 0;
        const CPaccount = `${tierExpirationDate}/${pointsToNextTier}/${qualificablePoints}/${extraBaggagesNumber}-${freeAMPlusSeat}`;
        const { passengerData = {} } = nextProps.userProfile;
        const dateOfBirth = passengerData.dateOfBirth;
        const residenceCountryCode = passengerData.residenceCountryCode;
        const UserProfilePreferences = passengerData.preferences && passengerData.preferences.wheelchair ? 1 : 0;
        const passportExpirationDate = (passengerData && passengerData.passports) && passengerData.passports._collection.map(passport => {
          return `${passport.expirationDate}`;
        }).join(':') || '';
        const passportIssuingCountry = (passengerData && passengerData.passports) && passengerData.passports._collection.map(passport => {
          return `${passport.issuingCountry}`;
        }).join(':') || '';
        const passportNationality = (passengerData && passengerData.passports) && passengerData.passports._collection.map(passport => {
          return `${passport.nationality}`;
        }).join(':') || '';
        const passportPrimary = (passengerData && passengerData.passports) && passengerData.passports._collection.map(passport => {
          return `${passport.primary ? 1 : 0}`;
        }).join(':') || '';
        const favoriteStoreFront = nextProps.userProfile && nextProps.userProfile.settings ? nextProps.userProfile.settings.favoriteStoreFront : '';
        const favoriteDepartureAirport = nextProps.userProfile && nextProps.userProfile.settings ? nextProps.userProfile.settings.favoriteDepartureAirport : '';
        const corporateNumber = nextProps.userProfile && nextProps.userProfile.corporateProgram ? nextProps.userProfile.corporateProgram.corporateNumber : 'NA';
        const passengerDataParsed = `${dateOfBirth}/${residenceCountryCode}/${UserProfilePreferences}/${passportExpirationDate}-${passportIssuingCountry}-${passportNationality}-${passportPrimary}/${favoriteStoreFront}/${favoriteDepartureAirport}/${corporateNumber}`;

        const travelersDateOfBirth = travelers > 0 ? nextProps.userProfile.travelers._collection.map(traveler => {
          return `${traveler.dateOfBirth}`;
        }).join(':') : '';
        const travelersGender = travelers > 0 ? nextProps.userProfile.travelers._collection.map(traveler => {
          return `${traveler.gender}`;
        }).join(':') : '';
        const travelersResidenceCountryCode = travelers > 0 ? nextProps.userProfile.travelers._collection.map(traveler => {
          return `${traveler.residenceCountryCode}`;
        }).join(':') : '';


        const vouchersinfoNum = nextProps.userProfile && nextProps.userProfile.vouchersInfo && nextProps.userProfile.vouchersInfo.vouchersNum || 0;
        const vouchersinfoExpiryDate = nextProps.userProfile && nextProps.userProfile.vouchersInfo && nextProps.userProfile.vouchersInfo.expiryDate || '';
        const vouchersNumSalonesPremier = nextProps.userProfile && nextProps.userProfile.vouchersSalonesInfo && nextProps.userProfile.vouchersSalonesInfo.vouchersNum || 0;
        const vouchersinfo = `${vouchersinfoNum}/${vouchersinfoExpiryDate}/${vouchersNumSalonesPremier}`;
        const travelersData = `${travelers}/${travelersDateOfBirth}/${travelersGender}/${travelersResidenceCountryCode}`;
        metricaUserLoginStep(dispatch, userType, clubPremierID, tierLvl, anioNacimiento, grupo, balance, genero, travelersData, paymentMethods, cobrandCards, CPaccount, passengerDataParsed, vouchersinfo);

        const userEmailCp = nextProps?.userProfile?.passengerData?.email || '';
        if (actionLoginNext) {
          dispatch(LOGIN_ACTION({ clubPremierID, userEmailCp }));

          dispatch(ACTION_LOGIN(false));
        }
        if (cobrandCards >= 1) {
          // Metrica Login cobranded
          metricaUserLoginCobranded(dispatch, pathname);

          // extrae la coleccion de cobranded
          const coBrandedCard = nextProps.userProfile.account.cobrandCardCollection._collection;

          metricaUserLoginCobrandedCard(dispatch, coBrandedCard, clubPremierID, pathname);
        }

        /*
          Redirect a profile cuando esta el persistentLogin,
          entra despues de iniciar sesión con el modalLogin
        */
        if (getTabIndex()) {
          const redirectHost = window.location.host;

          retriveActualHostUrl(redirectHost, language, storefront);
        }
      }

      if (isActivePersistentLoginPopup) {
        dispatch(disablePersistentLoginPopup());
      }
    }

    if (((this.validatorCode === '500601' || this.validatorCode === '500008' || this.validatorCode === '15530702' || this.validatorCode === '500208' || this.validatorCode === '15420703') && this.validatorCode === nextProps.codeInicativeAccount &&
      this.checkPoint1 === false && signInFail)) {
      // Metrica Credentias fail
      const errorType = 'Invalid Credentials';
      const button = localStorage.getItem('loginButton');
      metricaUserLoginFail(dispatch, pathname, errorType, button);
      this.validatorCode = '';
      this.checkPoint1 = true;
      this.checkPoint2 = false;
    }

    if (((this.validatorCode === '15530701' || this.validatorCode === '500211') && this.validatorCode === nextProps.codeInicativeAccount &&
      this.checkPoint2 === false && signInFail)) {
      // Metrica Inactive account
      const errorType = 'Inactive account';
      const button = localStorage.getItem('loginButton');
      metricaUserLoginFail(dispatch, pathname, errorType, button);
      this.validatorCode = '';
      this.checkPoint1 = false;
      this.checkPoint2 = true;
    }

    if (this.validatorCode === '15330708' && this.validatorCode === nextProps.codeInicativeAccount && signInFail) {
      const errorType = 'Unverified Email';
      const button = localStorage.getItem('loginButton');

      metricaUserLoginFail(dispatch, pathname, errorType, button);
      this.validatorCode = '';
      this.checkPoint1 = false;
      this.checkPoint2 = false;
    }

    if (this.validatorCode === '15110701' && this.validatorCode === nextProps.codeInicativeAccount && signInFail) {
      const errorType = 'Connectivity';
      const button = localStorage.getItem('loginButton');

      metricaUserLoginFail(dispatch, pathname, errorType, button);
      this.validatorCode = '';
      this.checkPoint1 = false;
      this.checkPoint2 = false;
    }

    if (this.validatorCode === '17531301' && this.validatorCode === nextProps.codeInicativeAccount && signInFail) {
      const errorType = 'Invalid Otp';
      const button = localStorage.getItem('loginButton');

      metricaUserLoginFail(dispatch, pathname, errorType, button);
      this.validatorCode = '';
      this.checkPoint1 = false;
      this.checkPoint2 = false;
    }

    if (this.validatorCode === '17531302' && this.validatorCode === nextProps.codeInicativeAccount && signInFail) {
      const errorType = 'User Blocked';
      const button = localStorage.getItem('loginButton');

      metricaUserLoginFail(dispatch, pathname, errorType, button);
      this.validatorCode = '';
      this.checkPoint1 = false;
      this.checkPoint2 = false;
    }

    if (this.validatorCode === '17531303' && this.validatorCode === nextProps.codeInicativeAccount && signInFail) {
      const errorType = 'Invalid Session Id';
      const button = localStorage.getItem('loginButton');

      metricaUserLoginFail(dispatch, pathname, errorType, button);
      this.validatorCode = '';
      this.checkPoint1 = false;
      this.checkPoint2 = false;
    }

    if (this.validatorCode === '17531304' && this.validatorCode === nextProps.codeInicativeAccount && signInFail) {
      const errorType = 'Otp Blocked';
      const button = localStorage.getItem('loginButton');

      metricaUserLoginFail(dispatch, pathname, errorType, button);
      this.validatorCode = '';
      this.checkPoint1 = false;
      this.checkPoint2 = false;
    }

    if (this.validatorCode === '100412' && codeInicativeAccount !== nextProps.codeInicativeAccount) {
      const storefront = this.getStorefrontFromUrl();
      const registerData = {
        storefront: storefront,
      };

      dispatch(sendAnalytics({
        eventCreator: registerFailCPTracking.registerFailCPTracking(registerData),
      }));
      this.validatorCode = '';
      this.checkPoint1 = false;
      this.checkPoint2 = false;
    }

    if (this.validatorCode === '500217' && codeInicativeAccount !== nextProps.codeInicativeAccount) {
      const storefront = this.getStorefrontFromUrl();
      const registerData = {
        storefront: storefront,
      };

      dispatch(sendAnalytics({
        eventCreator: registerFailCPTracking.registerFailCPTracking(registerData),
      }));

      this.validatorCode = '';
      this.checkPoint1 = false;
      this.checkPoint2 = false;
    }

    if (this.validatorCode === '15340701' && codeInicativeAccount !== nextProps.codeInicativeAccount) {
      const storefront = this.getStorefrontFromUrl();
      const registerData = {
        storefront: storefront,
      };

      dispatch(sendAnalytics({
        eventCreator: registerFailCPTracking.registerFailCPTracking(registerData),
      }));

      this.validatorCode = '';
      this.checkPoint1 = false;
      this.checkPoint2 = false;
    }

    if (this.validatorCode === '500214' && codeInicativeAccount !== nextProps.codeInicativeAccount) {
      const storefront = this.getStorefrontFromUrl();
      const registerData = {
        storefront: storefront,
      };

      dispatch(sendAnalytics({
        eventCreator: registerFailCPTracking.registerFailCPTracking(registerData),
      }));

      this.validatorCode = '';
      this.checkPoint1 = false;
      this.checkPoint2 = false;
    }

    if (this.validatorCode === '15530716' && codeInicativeAccount !== nextProps.codeInicativeAccount) {
      const storefront = this.getStorefrontFromUrl();
      const registerData = {
        storefront: storefront,
      };

      dispatch(sendAnalytics({
        eventCreator: registerFailCPTracking.registerFailCPTracking(registerData),
      }));

      metricaUserSignupFail(dispatch, {
        actionable: nextProps.errorActionable,
        actionType: nextProps.errorActionType,
        code: this.validatorCode,
        extraInfo: nextProps.errorExtraInfo,
        msg: nextProps.errorMsg,
        status: nextProps.errorStatusCode,
      });

      this.validatorCode = '';
      this.checkPoint1 = false;
      this.checkPoint2 = false;
    }

    // Entra el persistentLogin
    if (isSignIn !== nextProps.isSignIn && !isSignIn && localStorage.getItem('initials')) {
      dispatch(activatePersistentLoginPopup());
    }
  }

  componentDidUpdate(prevProps) {
    const {
      dispatch,
      isSignIn,
      loginMethod,
      metrixEmail,
      sourceOpenModalLogin,
    } = this.props;
    
    if (prevProps.isSignIn !== isSignIn && isSignIn && sourceOpenModalLogin) {
      metricaLogin(dispatch, sourceOpenModalLogin, loginMethod, metrixEmail);
    }
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  render() {
    const {
      activeBannerUpdateConsent,
      breakpointNewDesign,
      cityArrival,
      cityDestini,
      closeErrorBanner,
      country,
      dispatch,
      handleinfoPopUp,
      hasUpdateCart,
      helperTraslatedCopy,
      hideMenuList,
      initstopScrollPayment,
      isActiveFlowCorporate,
      isValidSession,
      language,
      mttParam,
      pnrInfo,
      refunds,
      showErrorBanner,
      showInformation,
      stopScrollPayment,
      storefrontData,
      userToken,
      userCorporate,
    } = this.props;
    const {
      inputValueSearchModal,
      modalSearch,
      modalSearchClose,
      showBanner,
      showHamburger,
      showSubmenu,
    } = this.state;

    const userCorporateData = JSON.parse(getCookie('userSessionCorporate'));
    const activeCompanyCookie = userCorporateData && userCorporateData.companySelected && userCorporateData.companySelected;
    const storefront = this.getStorefrontFromUrl();
    // Se comenta temporalmente estilo para un webview
    // const isValidBreakpoint = breakpointNewDesign === 'small' || breakpointNewDesign === 'medium';

    const headerCorporateFlow = cx({
      'Header': true,
      'Header-refund': refunds,
      'Header--corporate': isActiveFlowCorporate,
      // 'Header-webView': mttParam && isValidBreakpoint,
    });

    return (
      <div className={ headerCorporateFlow } id='HeaderId' >
        <HeaderMain
          activeCompany={ activeCompanyCookie }
          breakpointNewDesign={ breakpointNewDesign }
          cityArrival={ cityArrival }
          cityDestini={ cityDestini }
          closeHamburger={ this.handleCloseHamburger }
          country={ country }
          handleOpenSearchModal={ this.handleOpenSearchModal }
          handlePopUpSing={ handleinfoPopUp }
          hasUpdateCart={ hasUpdateCart }
          hideMenuList= { hideMenuList }
          initstopScrollPayment={ initstopScrollPayment }
          isActiveFlowCorporate={ isActiveFlowCorporate }
          isValidSession={ isValidSession }
          language={ language }
          mttParam={ mttParam }
          openHamburger={ this.handleOpenHamburger }
          pnrInfo={ pnrInfo }
          refunds={ refunds }
          showHamburger={ showHamburger }
          showInformation={ showInformation }
          stopScrollPayment={ stopScrollPayment }
          storefront={ storefront }
          storefrontData={ storefrontData }
          trackLoginUsername={ this.trackLoginUsername }
          userCorporate={ userCorporate }
          userToken={ userToken }
        />
        { breakpointNewDesign !== 'large' ?
          <HeaderMenuHamburger
            country={ country }
            closeHamburger={ this.handleCloseHamburger }
            isSubmenuOpen={ showSubmenu }
            language={ language }
            showMyTripsMenu={ true }
            type={ 'main' }
            showInformation={ showInformation }
            storefront={ storefront }
            showHamburger={ showHamburger }
            storefrontData={ storefrontData }
            onCloseSubmenu={ this.handleCloseSubmenu }
            onOpenSubmenu={ this.handleOpenSubmenu }
          />
          : null
        }
        { showErrorBanner ?
          <ErrorBar
            closeErrorBanner={ closeErrorBanner }
            language={ language }
          /> : null
        }
        { showBanner &&
          <ErrorBarIcon
            copyMessage={ activeBannerUpdateConsent.isSuccess ? 'PROFILE_CONFIRMATION_TYC_MESSAGE' : 'PROFILE_ERROR_TYC_MESSAGE' }
            dispatch={ dispatch }
            isSuccess={ activeBannerUpdateConsent.isSuccess }
            onClose={ () => this.onCloseBanner() }
          />
        }
        { modalSearch && !USE_AMAIA_CHAT &&
          <SearchModal
            handleCloseSearchModal={ this.handleCloseSearchModal }
            helperTraslatedCopy={ helperTraslatedCopy }
            inputValueSearchModal={ inputValueSearchModal }
            modalSearchClose={ modalSearchClose }
          />
        }
        { modalSearch && USE_AMAIA_CHAT &&
          <AmaiaChat
            handleCloseSearchModal={ this.handleCloseSearchModal }
            helperTraslatedCopy={ helperTraslatedCopy }
            modalSearchClose={ modalSearchClose }
          />
        }
      </div>
    );
  }

  handleOpenSearchModal() {
    this.setState({
      modalSearch: true,
      modalSearchClose: false,
    });
  }

  trackLoginUsername(username) {
    const { dispatch } = this.props;
    dispatch(setModalLoginMethod(username));
  }

  // Se crea el cierre de modal a mano para limpiar el input value y que no se dispare la metrica
  handleCloseSearchModal() {
    this.setState({ modalSearchClose: true });
    setTimeout(() => {
      this.setState({
        inputValueSearchModal: true,
        modalSearch: false,
      });
    }, 400);
  }

  dispatchCookieUserCases = (option) => { // It will be a useful helper.
    const {
      country,
      dispatch,
      isInvalidSession,
      language,
      pnrInfo,
      remainingAttemptsRetrieveProfile,
      userToken,
    } = this.props;

    const userSession = getCookie('userSession');
    let _token = null;
    const userCorporateData = JSON.parse(getCookie('userSessionCorporate'));
    const corporatePNR = Boolean(pnrInfo?.isCorporateFlow && pnrInfo?.corporateFlow);
    const isCorporateFlow = userCorporateData?.isUserCorporate || corporatePNR;
    const corporateProvider = userCorporateData ? userCorporateData?.CorporateSupplier : corporatePNR && pnrInfo?.corporateFlow.provider;
    let pos = {};

    if (!isCorporateFlow) {
      pos = {
        'store': country,
        'pos': 'WEB',
        'language': language,
      };
    } else {
      pos = {
        'store': country,
        'pos': 'WEB',
        'language': language,
        'isCorporateFlow': isCorporateFlow,
        'corporateName': corporateProvider,
      };
    }

    if (!isInvalidSession && userSession) {
      _token = JSON.parse(userSession).userToken;
    } else return;

    switch (option) {
      case 'retrieve_profile': // The user comes from www.aeromexico.com and there is a session already.
        if (remainingAttemptsRetrieveProfile < 1) {
          break;
        }
        dispatch(retrieveProfileUserAction(_token, pos)); // Retrieve user's profile and user's trips.
        break;
      case 'retrieve_corporate_profile':
        dispatch(retrieveCorporateProfileUserAction(_token, pos)); // Retrieve user's corporate profile and user's trips.
        break;
      case 'check_session':
        dispatch(checkSessionAction(_token, pos));
        break;
      case 'user_logout':
        if (userToken) // state
          dispatch(logoutSessionAction(userToken, pos));
        else if (_token) // browser
          dispatch(logoutSessionAction(_token, pos));
        else if (!userToken && !_token)
          return;
        break;
      default:
        break;
    }
  }

  handleOpenHamburger() {
    const { showHamburger } = this.state;
    const htmlTag = document.getElementsByTagName('html')[0];
    this.setState({ showHamburger: !showHamburger });

    if (!showHamburger) {
      htmlTag.classList.add('Modal-open--state');
    }
  }

  handleCloseHamburger() {
    const htmlTag = document.getElementsByTagName('html')[0];

    htmlTag.classList.remove('Modal-open--state');

    this.setState({
      showHamburger: false,
      showSubmenu: false,
    });
  }

  handleOpenSubmenu() {
    this.setState({
      showSubmenu: true,
    });
  }

  handleCloseSubmenu() {
    this.setState({
      showSubmenu: false,
    });
  }

  getStorefrontFromUrl() {
    const destructuringUrl = window.location.pathname;
    const regex = /\/(\w+)-(\w+)\//g;
    return destructuringUrl.match(regex) === null ? 'es-mx' : destructuringUrl.match(regex)[0].slice(1, -1);
  }

  onCloseBanner = () => {
    this.setState({ showBanner: false });
  }

  retrieveCorporateProfileData() {
    const {
      dispatch,
    } = this.props;
    const userCorporateData = JSON.parse(getCookie('userSessionCorporate'));

    // busca la informacion en la cookie o en localStorage
    const isCorporateFlowCookie = userCorporateData?.isUserCorporate;
    const activeCompanyCookie = userCorporateData?.companySelected;
    const CorporateSupplierCookie = userCorporateData?.CorporateSupplier;
    // pasa la informacion de la cookie al localStorage
    dispatch(actions.setCompanySelected(activeCompanyCookie));
    dispatch(actions.setCorporateSupplierSelected(CorporateSupplierCookie));
    dispatch(actions.setFlowCorporateIsActive(isCorporateFlowCookie));
    dispatch(actions.setRetrieveCorporateData(true));
    localStorage.setItem('companySelected', activeCompanyCookie);
    localStorage.setItem('corporateSupplierSelected', CorporateSupplierCookie);
    localStorage.setItem('corporateFlow', isCorporateFlowCookie);
  }
}
Header = connect(mapStateToProps)(Header);

export default withWindow(withRouter(Header));
